<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_vii"><strong>Contents</strong></a></p><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/xhtml/9780226432212_07_Ack#ack">Acknowledgments</a></p>
<p class="toca"><a href="#/xhtml/9780226432212_08_Int#int"><strong>Introduction</strong></a></p>
<p class="toc-authora">Daniel P. Kessler</p>
<p class="toc-chap"><a href="#/xhtml/9780226432212_09_Ch1#ch1"><strong>1. Regulation (Agencies) versus Litigation (Courts): An Analytical Framework</strong></a></p>
<p class="toc-author">Richard A. Posner</p>
<p class="toc-chap"><a href="#/xhtml/9780226432212_10_Ch2#ch2"><strong>2. Efficient Regulation</strong></a></p>
<p class="toc-author">Andrei Shleifer</p>
<p class="toc-chap"><span href="#/xhtml/9780226432212_11_Ch3#ch3" title="Link target outside of Sample"><strong>3. The Trouble with Cases</strong></span></p>
<p class="toc-author">Frederick Schauer and Richard Zeckhauser</p>
<p class="toc-chap"><span href="#/xhtml/9780226432212_12_Ch4#ch4" title="Link target outside of Sample"><strong>4. Tobacco Regulation through Litigation: The Master Settlement Agreement</strong></span></p>
<p class="toc-author">W. Kip Viscusi and Joni Hersch</p>
<p class="toc-chap"><span href="#/xhtml/9780226432212_13_Ch5#ch5" title="Link target outside of Sample"><strong>5. Gun Control after <em>Heller</em>: Litigating against Regulation</strong></span></p>
<p class="toc-author">Philip J. Cook, Jens Ludwig, and Adam Samaha</p>
<p class="toc-chap"><span href="#/xhtml/9780226432212_14_Ch6#ch6" title="Link target outside of Sample"><strong>6. The Effects of Product Liability Exemption in the Presence of the FDA</strong></span></p>
<p class="toc-author">Tomas J. Philipson, Eric Sun, and Dana Goldman</p>
<p class="toc-chap"><span href="#/xhtml/9780226432212_15_Ch7#ch7" title="Link target outside of Sample"><strong>7. The Impact of Employment Protection on Workers Disabled by Workplace Injuries</strong></span></p>
<p class="toc-author">Adam H. Gailey and Seth A. Seabury</p>
<p class="toc-chap"><span href="#/xhtml/9780226432212_16_Ch8#ch8" id="page_viii" title="Link target outside of Sample"><strong>8. Opting Out of Workers’ Compensation in Texas: A Survey of Large, Multistate Nonsubscribers</strong></span></p>
<p class="toc-author">Alison Morantz</p>
<p class="toc-chap"><span href="#/xhtml/9780226432212_17_Ch9#ch9" title="Link target outside of Sample"><strong>9. M&amp;A Break Fees: U.S. Litigation versus UK Regulation</strong></span></p>
<p class="toc-author">John C. Coates IV</p>
<p class="toc-chap"><span href="#/xhtml/9780226432212_18_Ch10#ch10" title="Link target outside of Sample"><strong>10. Exploring Ex Ante Regulatory Mechanisms for Detecting Prescription Drug Misuse</strong></span></p>
<p class="toc-author">Stephen T. Parente</p>
<p class="toc-chap"><span href="#/xhtml/9780226432212_19_Ch11#ch11" title="Link target outside of Sample"><strong>11. Natural Disaster Management: Earthquake Risk and Hospitals’ Provision of Essential Services in California</strong></span></p>
<p class="toc-authora">Tom Chang and Mireille Jacobson</p>
<p class="toc"><span href="#/xhtml/9780226432212_21_Con#con" title="Link target outside of Sample">Contributors</span></p>
<p class="toc"><span href="#/xhtml/9780226432212_22_Ind1#ind" title="Link target outside of Sample">Author Index</span></p>
<p class="toc"><span href="#/xhtml/9780226432212_23_Ind2#ind1" title="Link target outside of Sample">Subject Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226432212_06_Toc.vue?be2d0e20